import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { createStyles, makeStyles } from "@mui/styles";
import { MessageLeft, MessageRight } from "./Message";
import moment from "moment/moment";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import ListItemButton from "@mui/material/ListItemButton";
import {
  getDocs,
  collection,
  query,
  orderBy,
  onSnapshot,
  where,
  doc,
  getDoc,
} from "firebase/firestore";
import { db } from "../firebase_conf";

const useStyles = makeStyles(() =>
  createStyles({
    paper: {
      width: "80vw",
      height: "100%",
      maxWidth: "500px",
      maxHeight: "700px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
    },
    container: {
      width: "100%",
      height: "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    messagesBody: {
      width: "100%",
      overflowY: "scroll",
      height: "100%",
      maxHeight:'65vh',
      padding:10
    },
  })
);

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(0),
  color: theme.palette.text.secondary,
  borderRadius: 0,
}));

const Chats = () => {
  const classes = useStyles();
  const [convo, setConvo] = useState([]);
  const [chatSelected, setChatSelected] = useState(false);
  const [senderProfile, setSenderProfile] = useState({});
  const [chats, setChats] = useState([]);

  const handleChat = async (id, senderId, receiverId) => {
    setChatSelected(id);
    const q = query(
      collection(db, "chat"),
      where("senderId", "in", [senderId, receiverId])
    );

    const querySnapshot = await getDocs(q);
    let chat_list = [];
    querySnapshot.forEach((doc) => {
      chat_list.push({ ...doc.data(), id: doc.id });
    });
    console.log(chat_list);
    setChats(chat_list);

    // get sender profile
    const docRef = doc(db, "users", senderId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setSenderProfile({ ...docSnap.data(), id: docSnap.id });
    } else {
      console.log("No such document!");
    }
  };
  useEffect(() => {
    let isMounted = true;
    const q = query(
      collection(db, "conversations"),
      orderBy("timestamp", "desc")
    );
    onSnapshot(q, (snapshot) => {
      if (isMounted) {
        setConvo(snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
      }
    });
    return () => {
      isMounted = false;
    };
  }, []);
  useEffect(() => {
    console.log(chats);
  }, [chats]);

  return (
    <Container maxWidth="lg">
      <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 4}}>
        <Link underline="hover" color="inherit" href="/">
          Home
        </Link>
        <Typography color="text.primary">Chats</Typography>
      </Breadcrumbs>
      <Box sx={{ mt:2 }}>
        <Box sx={{ flexGrow: 1, p: 2 }}>
          <Grid container spacing={5}>
            <Grid item xs={6}>
              <Item sx={{ borderRadius: 2 }}>
                <Box sx={{ height: '70vh' }}>
                  <Typography
                    variant="h6"
                    gutterBottom
                    style={{ textAlign: "center" }}
                  >
                    Conversations
                  </Typography>
                  <List
                    sx={{
                      width: "100%",
                      position: "relative",
                      overflow: "auto",
                      maxHeight: '70vh',
                      margin: "auto",
                      "& ul": { padding: 2 },
                    }}
                  >
                    {convo.map((item) => (
                      <ListItemButton
                        key={item.id}
                        selected={chatSelected === item.id}
                        onClick={() =>
                          handleChat(item.id, item.senderId, item.receiverId)
                        }
                        sx={{background:'#64b5f6', borderRadius:'8px', margin:'8px'}}
                      >
                        <ListItem>
                          <ListItemText
                            primary={`${item.senderName} -- ${item.receiverName}`}
                            secondary={`${item.lastMessage} ${moment(
                              new Date(item.timestamp.seconds * 1000)
                            ).format("LLL")}`}
                          />
                        </ListItem>
                      </ListItemButton>
                    ))}
                  </List>
                </Box>
              </Item>
            </Grid>
            <Grid item xs={6}>
              <Item sx={{ borderRadius: 2 }}>
                <Box sx={{ height: '70vh' }}>
                  <Typography
                    variant="h6"
                    gutterBottom
                    style={{ textAlign: "center" }}
                  >
                    Chats
                  </Typography>
                  <div className={classes.container}>
                    <Paper className={classes.paper}>
                      <Paper id="style-1" className={classes.messagesBody}>
                        {chats.map((item) => {
                          if (item.senderId === senderProfile.id) {
                            return (
                              <MessageLeft
                                message={item.message}
                                timestamp={`${moment(
                                  new Date(item.timestamp.seconds * 1000)
                                ).format("LLL")}`}
                                // photoURL="https://lh3.googleusercontent.com/a-/AOh14Gi4vkKYlfrbJ0QLJTg_DLjcYyyK7fYoWRpz2r4s=s96-c"
                                displayName={senderProfile.full_name}
                                avatarDisp={false}
                              />
                            );
                          } else {
                            return (
                              <MessageRight
                                message={item.message}
                                timestamp={`${moment(
                                  new Date(item.timestamp.seconds * 1000)
                                ).format("LLL")}`}
                                // photoURL="https://lh3.googleusercontent.com/a-/AOh14Gi4vkKYlfrbJ0QLJTg_DLjcYyyK7fYoWRpz2r4s=s96-c"
                                displayName=""
                                avatarDisp={false}
                              />
                            );
                          }
                        })}
                      </Paper>
                    </Paper>
                  </div>
                </Box>
              </Item>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};

export default Chats;
